import React from 'react';
import { CheckCircle2, AlertCircle, AlertTriangle } from 'lucide-react';

export const Legend = () => {
  const items = [
    { label: 'Healthy', color: '#1D9E75', Icon: CheckCircle2 },
    { label: 'Broken', color: '#E63946', Icon: AlertCircle },
    { label: 'At-Risk', color: '#FCA311', Icon: AlertTriangle }
  ];

  return (
    <div 
      data-testid="pipeline-legend"
      className="flex items-center justify-center gap-6 py-3 px-4 bg-white/80 backdrop-blur-sm rounded-lg border border-[#E2E8F0]"
    >
      {items.map(({ label, color, Icon }) => (
        <div key={label} className="flex items-center gap-2">
          <div className="w-4 h-4 rounded-full flex items-center justify-center" style={{ backgroundColor: color }}>
            <span className="text-white text-[8px] font-bold">
              {label === 'Healthy' ? '✓' : label === 'Broken' ? '!' : '⚠'}
            </span>
          </div>
          <span className="text-xs uppercase tracking-[0.1em] font-semibold text-[#1A3A5C]/60">
            {label}
          </span>
        </div>
      ))}
    </div>
  );
};

export default Legend;
